import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MainMiniappBottomNav } from '@miniapp-core/components';

const PROFILE_IMAGE_URL =
  'https://lh3.googleusercontent.com/aida/ADBb0ujFYAF_wY8LOr_JL5i2vEKIcdlQnmuyo0FO0z9MsgTxeTeNMiHcQkRGNVeaZfoFsyg_otcU2LRNb93fqXOL6cJKs0Zih0pKJjcBi80ho6l4LfQtRouierCAXRBYvcbB4usHECZRm0rOA7EoOOkCxYZWicdbVSeNL5Zze4cumW_Vnj73M_gXt3HDO2XGlG4QuEFN5Fu4hBah3JCKAXvByHfzPr-OrjoF5xZG6_Rh8YAszaZyjV36oT8PVh8_X3I8AMOXU3GD2Dowvls';
const INSTAGRAM_ICON_IMAGE_URL =
  'https://lh3.googleusercontent.com/aida/ADBb0uiwMzLRFtMseasqlzUEODlTuQa5UPFZMMFWMg2aHL2D5QSjaTtgw0YqInTSZ_5ZbL43qBDeqxYDyoR6C6t_lvrHxbYDV1t5siXwlfksk3uqi8VL9lY4yOSgsNUTwdTM1LkNSHu6LuC0Em37aMc2AyIaWnr5tyYegf6MnklK3ClPfW4sTUM8GVrHFd1wNDEApAYvnuGCVU1smSIxZcVsFfjlDi9ncCOA9tFwLZhCeH9nZEEbh7xeYjnsI0hlxXE1YwmUxxRuS_xuoAM';
const YOUTUBE_ICON_IMAGE_URL =
  'https://lh3.googleusercontent.com/aida/ADBb0ujiAkl82NpU947HyU6CTJN-DPYiXEIGTR4hxX2rQkyDEw73TzguMqKysU4ANJFkMtVMiWecWokNCmnvWSzVQk3WQur_4hLm1K1FFkgh75jIYqbg9MDf3O3yr90KrOZiID4kTfmQU98vfw1GOzPSBX4u8k8ktgPOWPmvLdyWOFhGI6nDdaQp9iCOwxmm3KjoIxzRkzCg2Zw7GrYVhXQoO7kwmYufLgz2iEMMecdEADx1nymiOhHw8Kx5CqvqwuVs_7fzk8ZwVJeLqfQ';
const BOOSTY_ICON_IMAGE_URL =
  'https://lh3.googleusercontent.com/aida/ADBb0ui1Pdtnc0VlJCAhDAl9VAVr8JrDxJscNLD2Xf5vM0ClmTf0uwiojtOBkBnuAR8WXTjDBkIxLVStf5iCRS0yvSf7QwquYj8x7OAlZTQOCSQFRTS2FkFqFFbxdxTiXG_jhyDoATJBfKH833y6SJ3KmNfbBgaSDFcVmt5bhNVldkfEgPLhbgIaXk0el6AR2fKtEVsmX77UWDdLlk4o1OAT8c5H7AIbOAw9nVeVMpOjuAJ9dzKSpc5XxLq3ZHK-Z01vQXKNYAtS4CpahqY';
const TIKTOK_ICON_IMAGE_URL =
  'https://lh3.googleusercontent.com/aida/ADBb0ujWimFmtNLG97QEUgDzetWieybu_RiNuY4PNGPMsJcHnLuN_60zHgE14b6wURPmbuspP8sodP4Xzvp8q_pU_Tu1HzzwvgtogAJY1xk7R4WQuVxqzH_7Li9fMe9lbgMIQYjQJs0o2W4BFPd9IK2xhdoUABj33Vuc-5Pb0ednoMayP1olxEECg8W9Y9jutp2zzf6tx5YZM9uN2ZIemcFbByPzdLexVL7UnIDIRTicab1rkhSUlLLJ6vKjFpY9cQ20TVhinbwzD28SXjo';

interface NavigatorLink {
  href: string;
  labelKey: string;
  icon: 'material' | 'image';
  iconValue: string;
}

const NAVIGATOR_LINKS: NavigatorLink[] = [
  {
    href: 'https://example.com/',
    labelKey: 'website',
    icon: 'material',
    iconValue: 'language',
  },
  {
    href: 'https://www.instagram.com/',
    labelKey: 'instagram',
    icon: 'image',
    iconValue: INSTAGRAM_ICON_IMAGE_URL,
  },
  {
    href: 'https://www.youtube.com/',
    labelKey: 'youtube',
    icon: 'image',
    iconValue: YOUTUBE_ICON_IMAGE_URL,
  },
  {
    href: 'https://boosty.to/',
    labelKey: 'boosty',
    icon: 'image',
    iconValue: BOOSTY_ICON_IMAGE_URL,
  },
  {
    href: 'https://t.me/',
    labelKey: 'telegramChannel',
    icon: 'material',
    iconValue: 'send',
  },
  {
    href: 'https://www.tiktok.com/',
    labelKey: 'tiktok',
    icon: 'image',
    iconValue: TIKTOK_ICON_IMAGE_URL,
  },
];

function openExternalLink(url: string): void {
  if (window.Telegram?.WebApp?.openLink) {
    window.Telegram.WebApp.openLink(url);
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export default function NavigatorScreen() {
  const { t } = useTranslation('shell');
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-background text-on-background antialiased">
      <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
        <div className="absolute -left-[10%] -top-[20%] h-[70vw] w-[70vw] rounded-full bg-primary-container/20 blur-[100px]" />
        <div className="absolute -bottom-[20%] -right-[10%] h-[60vw] w-[60vw] rounded-full bg-secondary-container/20 blur-[100px]" />
      </div>

      <header className="fixed top-0 z-50 flex h-16 w-full items-center justify-between border-b border-white/10 bg-[#0d0c4b]/80 px-5 shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-xl">
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center justify-center text-primary-container transition-opacity duration-200 hover:opacity-80 active:scale-95"
        >
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <h1 className="font-headline text-[24px] font-bold uppercase tracking-tight text-primary-container">KK</h1>
        <button
          type="button"
          className="flex items-center justify-center text-white/70 transition-opacity duration-200 hover:opacity-80 active:scale-95"
        >
          <span className="material-symbols-outlined">account_circle</span>
        </button>
      </header>

      <main className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-5 pb-28 pt-24">
        <section className="mb-16 mt-10 flex w-full flex-col items-center">
          <div className="mb-6 h-32 w-32 overflow-hidden rounded-full border-2 border-primary-container/30 shadow-[0_0_30px_rgba(255,150,104,0.2)]">
            <img src={PROFILE_IMAGE_URL} alt={t('navigator.profileAlt')} className="h-full w-full object-cover" />
          </div>
          <h2 className="mb-2 text-center font-headline text-[32px] font-bold leading-tight text-on-background">
            {t('navigator.title')}
          </h2>
          <p className="max-w-md text-center text-base leading-relaxed text-on-surface-variant">
            {t('navigator.subtitle')}
          </p>
        </section>

        <section className="flex w-full flex-col gap-3">
          {NAVIGATOR_LINKS.map((item) => (
            <button
              key={item.labelKey}
              type="button"
              onClick={() => openExternalLink(item.href)}
              className="glass-panel group relative flex w-full items-center justify-between overflow-hidden rounded-lg p-3 text-left transition-colors duration-200 hover:bg-white/10 active:scale-95"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-primary-container/10 to-secondary-container/10 opacity-0 transition-opacity group-hover:opacity-100" />
              <div className="relative z-10 flex items-center gap-6">
                <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-surface-container-high text-primary-container">
                  {item.icon === 'material' ? (
                    <span className="material-symbols-outlined">{item.iconValue}</span>
                  ) : (
                    <img src={item.iconValue} alt="" className="h-full w-full object-cover opacity-80 mix-blend-screen" />
                  )}
                </div>
                <span className="font-headline text-[24px] font-semibold leading-tight text-on-background">
                  {t(`navigator.links.${item.labelKey}`)}
                </span>
              </div>
              <span className="material-symbols-outlined relative z-10 text-on-surface-variant">chevron_right</span>
            </button>
          ))}
        </section>

        <section className="mt-10 flex w-full justify-center">
          <button
            type="button"
            onClick={() => openExternalLink('https://t.me/')}
            className="w-full rounded-full bg-[linear-gradient(90deg,#FF9668_0%,#8E1F78_100%)] px-10 py-6 font-label-mono text-sm uppercase tracking-[0.18em] text-white shadow-[0_4px_20px_rgba(255,150,104,0.3)] transition-opacity duration-200 hover:opacity-90 active:scale-95 sm:w-auto"
          >
            {t('navigator.consultation')}
          </button>
        </section>
      </main>

      <MainMiniappBottomNav
        activeRoute="navigator"
        labels={{
          home: t('footer.home'),
          materials: t('footer.materials'),
          events: t('footer.events'),
          navigator: t('footer.navigator'),
        }}
      />
    </div>
  );
}
